import _extends from "@babel/runtime/helpers/extends";
import { Search as SearchIcon } from '@wix/wix-ui-icons-common/on-stage';
import React, { useCallback } from 'react';
import { TextField } from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '../../../../contexts/translation-context';
import { classes, st } from './search.st.css';
import { useConfig } from '../../../../contexts/config-context';
export const Search = _ref => {
  let {
    autoFocus,
    className,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    isRTL: rtl
  } = useConfig();
  const handleRef = useCallback(input => {
    if (!autoFocus || !input) {
      return;
    }

    // Use setTimeout to defer focus, ensuring the input is mounted before attempting to focus.
    setTimeout(() => {
      input.focus();
    });
  }, [autoFocus]);
  return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    inputRef: handleRef,
    "data-hook": "country-search",
    className: st(classes.root, {
      rtl
    }, className),
    prefix: /*#__PURE__*/React.createElement(SearchIcon, null),
    placeholder: t('field.phone.country-search-input.placeholder'),
    "aria-label": t('field.phone.country-search-input.aria-label'),
    autoComplete: "off"
  }));
};
//# sourceMappingURL=search.js.map